import Http from "@/frontend/lib/Http";
import {AddressLookup, CustomerLookup, TuCheckResult, TuVerifiedAddress} from "@/frontend/types";
import { WidgetShop, WidgetVerification } from "@/types/frontend";

class Api {
    async getShop(params: object): Promise<WidgetShop> {
        const res = await Http.get("/get-shop", {
            params,
        });
        return res.data.data;
    }

    async addressLookup(params: object): Promise<AddressLookup[]> {
        const response = await Http.get("/address/lookup", {
            params,
        });
        return response.data;
    }

    async addressSelector(params: object): Promise<TuVerifiedAddress> {
        const response = await Http.get("/address/selector", {
            params,
        });
        return response.data;
    }

    async tuCheck(params: object): Promise<TuCheckResult> {
        const response = await Http.get("/tu-check", {
            params,
        });
        return response.data;
    }

    async getTuCheckVerification(params: object): Promise<WidgetVerification> {
        const res = await Http.get("/tu-check-verification", {
            params,
        });
        return res.data.data;
    }
    async customerLookup(params: object): Promise<CustomerLookup> {
        const response = await Http.get("/customer/lookup", {
            params,
        });
        return response.data;
    }
}

export const api = new Api();
